import React, { useState } from 'react'
import { Select, Option } from '@mui/joy'
import { GUITAR_TUNINGS } from '../../data/tunings'
import './tuningSelector.scss'
import CustomTuning from '../custom-tuning-modal/CustomTuning'

const TuningSelector = ({ tuning, setTuning }) => {
    const [modalOpen, setModalOpen] = useState(false);

    const handleTuningChange = (__event, newValue) => {
        if (newValue !== 'custom') {
            setTuning(newValue);
        }
    }

    const isPresetTuning = GUITAR_TUNINGS.some(t =>
        JSON.stringify(t.notes) === JSON.stringify(tuning)
    );

    const currentValue = isPresetTuning ? tuning : 'custom';

    return (
        <div className='tuning-selector'>
            <Select value={currentValue} onChange={handleTuningChange} variant='soft' color='primary'>
                <Option onClick={() => setModalOpen(true)} value={'custom'}>
                    {isPresetTuning ? 'Custom' : `Custom - [${[...tuning].reverse()}]`}
                </Option>
                {
                    GUITAR_TUNINGS.map((t) => (
                        <Option key={t.name} value={t.notes}>{t.name + ' -  [' + [...t.notes].reverse() + ']'}</Option>
                    ))
                }
            </Select>
            <CustomTuning modalOpen={modalOpen} setModalOpen={setModalOpen} tuning={tuning} setTuning={setTuning}></CustomTuning>
        </div>
    )
}

export default TuningSelector